import { Logger } from './logger.js';

// Date Utilities - Timezone-aware date conversion for Office.js
export class DateUtils {
  static toISOString(dateValue) {
    if (!dateValue) return new Date().toISOString();

    let date;

    if (dateValue instanceof Date) {
      date = dateValue;
    } else if (typeof dateValue === 'string') {
      date = new Date(dateValue);
      if (isNaN(date.getTime())) {
        return new Date().toISOString();
      }
    } else if (dateValue && typeof dateValue === 'object') {
      if (typeof dateValue.getAsync === 'function') {
        Logger.warn('Date property has async getAsync method - this needs async handling');
        return new Date().toISOString();
      }
      const timeValue = dateValue.time || dateValue.value || dateValue;
      date = new Date(timeValue);
    } else {
      date = new Date();
    }

    const tzOffset = date.getTimezoneOffset();
    const adjustedDate = new Date(date.getTime() - tzOffset * 60000);

    Logger.debug('Date conversion:', {
      original: date.toString(),
      tzOffset,
      adjusted: adjustedDate.toISOString()
    });

    return adjustedDate.toISOString();
  }
}


